import * as yup from 'yup';

export const AddressDataSchema = yup.object({
  street: yup.string().notRequired().nullable(),
  number: yup.string().notRequired().nullable(),
  zipCode: yup.string().notRequired().nullable(),
  city: yup.string().notRequired().nullable(),
});

export interface IAddressData {
  street?: string;
  number?: string;
  zipCode?: string;
  city?: string;
}
export const UpdateAddressDataSchema = yup
  .object({
    id: yup.string().required(),
  })
  .concat(AddressDataSchema);

export interface IUpdateAddressData extends IAddressData {
  id: string;
}
